import {
    AosSeverity,
    severityColorsMapping,
} from 'aos-services/src/services/common/types/AosSeverity'
import { TaskCategory } from 'aos-services/src/services/tasks/types/TaskCategory'
import { InfoBar } from 'aos-ui/src/components/infobar/InfoBar'
import React, { FC } from 'react'

import { taskItemIconVariant } from '../../utils'
import { TaskIcon } from './TaskIcon'

interface IconTaskItemProps {
    severity: AosSeverity
    category: TaskCategory
}

export const IconTaskItem: FC<IconTaskItemProps> = props => {
    return (
        <InfoBar color={severityColorsMapping[props.severity]} padding={8} shadowed>
            <TaskIcon
                category={props.category}
                iconVariant={taskItemIconVariant(false, { severity: props.severity })}
            />
        </InfoBar>
    )
}
